import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue3-cookies';
import { useIsErrorStore } from './stores/isError';
import ApiClient from './ApiClient';

window.addEventListener('error', (event) => {
  console.log(event);
  alert('システムで予期せぬエラーが発生しました。\n' + event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.log(event);
  alert('システムで予期せぬエラーが発生しました。\n' + event.reason);
});

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BFF_API_BASE,
  headers: { 'Content-Type': 'application/json;charset=utf-8', 'Access-Control-Allow-Origin': '*' },
});

const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(VueAxios, axiosInstance);
app.use(VueCookies, {
  expireTimes: '1d',
  path: '',
  domain: '',
  secure: true,
});
app.use(ApiClient, axiosInstance);

const pinia = createPinia();
app.use(pinia);
const errorState = useIsErrorStore();

app.config.globalProperties.$axios = axiosInstance;

app.config.errorHandler = function (err, vm, info) {
  console.log(err);
  console.log(vm);
  console.log(info);
  errorState.isError = true;
};

router.app = app;

app.mount('#app');
